import { __assign, __read } from "tslib";
import React, { useEffect, memo, useState, useCallback } from 'react';
/**
 * ХОК позволяющий управлять состоянием открытия и закрытия.
 */
export var withTogglable = function (WrappedComponent) {
    var WithTogglable = memo(function (props) {
        var opened = props.opened, setOpened = props.setOpened;
        var _a = __read(useState(Boolean(opened)), 2), localOpened = _a[0], setLocalOpened = _a[1];
        useEffect(function () {
            if (typeof opened === 'boolean' && localOpened !== opened) {
                setLocalOpened(opened);
            }
        }, [localOpened, opened]);
        var handleSetOpened = useCallback(function (nextOpened) {
            setLocalOpened(nextOpened);
            if (setOpened) {
                setOpened(nextOpened);
            }
        }, [setOpened]);
        return React.createElement(WrappedComponent, __assign({}, props, { opened: localOpened, setOpened: handleSetOpened }));
    });
    return WithTogglable;
};
